/**
 * Site-wide constants.
 *
 * Change SITE_BASE here when the domain changes — Seo, sitemap, and any
 * other component that builds absolute URLs pull from this single source.
 */

export const SITE_NAME = 'Anna Sacher Santana'
export const SITE_BASE = 'https://www.sachersantana.com'
export const SITE_TAGLINE = 'Skulpturen Portfolio'
